<template>
    <div>
      <v-container>
    
       <v-row>
   
         <v-col cols="12">
                   <v-card elevation="1">
                  <v-toolbar elevation="1">
                    <v-icon left color="primary">mdi-cogs</v-icon> Settings  <v-divider vertical inset class="ml-5 mr-2"/> <v-icon color="warning" @click="lock=!lock">mdi-{{lock?'lock-open-variant':'lock'}}</v-icon>
                    <v-spacer/>
                   
                  </v-toolbar>
                  <v-card-text>
                    <div><v-icon small left >mdi-domain</v-icon>Business Information</div>
                    <v-divider class="mb-4 mt-1"/>

                      <v-row>
                        <v-col cols="8">
                          <v-text-field
                              v-model="company_name"
                              @change="Update('company_name', company_name)"
                              dense
                              :disabled="lock"
                              label="Name"
                            ></v-text-field> 
                            <v-text-field
                              v-model="company_address"
                              @change="Update('company_address', company_address)"
                              dense
                              label="Address"
                               :disabled="lock"
                            ></v-text-field> 
                            <v-text-field
                              v-model="company_mobile"
                              @change="Update('company_mobile', company_mobile)"
                              dense
                              label="Mobile No."
                               :disabled="lock"
                            ></v-text-field> 
                             <v-text-field
                              v-model="company_tel"
                              @change="Update('company_tel', company_tel)"
                              dense
                              label="Telephone No."
                               :disabled="lock"
                            ></v-text-field> 
                              <v-text-field
                              v-model="company_email"
                              @change="Update('company_email', company_email)"
                              dense
                              label="Email"
                               :disabled="lock"
                            ></v-text-field> 
                        </v-col>  
                         <v-col cols="4" class="text-center">
                                  <img
                                    width="60%"
                                   @click="s3upload = true" class="imgsrc"
                                  v-if="company_logo != '' && company_logo != null"
                                  :src="company_logo"
                                  >
                                  <img v-else :src="$store.state.imgholder"  @click="s3upload = true" class="imgsrc"   width="60%" />
                               
                               <zera-s3-upload v-if="!lock" :show="s3upload" @zeraEvent="s3Ev"/>
                             
                         </v-col>
                      </v-row>     
                    <div class="mt-4"><v-icon small left >mdi-store-cog</v-icon>Operations </div>
                    <v-divider class="mb-4 mt-1"/>
                       <v-row>

                        <v-col cols="4">
                     
                                <p class="font-weight-bold"><v-icon left>mdi-store</v-icon> Service Bay |  
                                  <v-btn small text color="info" fab  @click="state='new', bayform = true"><v-icon>mdi-plus</v-icon></v-btn></p>
                                 <div class="mt-4 mb-4">
                                   
                                </div>
                                  <div v-for="(bay,index) in service_bays" :key="index+'-sb'">
                                      <v-icon left small color="error" v-if="!lock" @click="service_bay = bay, state='modify', bayform = true">mdi-pencil</v-icon>{{bay.name}}
                                       <span class="font-italic" v-if="!IsEmpty(bay.description)"> - {{bay.description}}</span>
                                    <v-divider class="mt-1 mb-1"/>
                                </div>
                               
                              </v-col>

                        <v-col cols="4">
                     
                                <p class="font-weight-bold"><v-icon left>mdi-account-group</v-icon> User Roles</p>

                                 <div class="mt-4 mb-4">
                                    <v-text-field
                                        v-model="new_role"
                                        dense
                                        label="New Role"
                                        hide-details
                                        :disabled="lock"
                                        solo
                                       @click:append-outer = "newRole()"
                                        append-outer-icon="mdi-plus"
                                      ></v-text-field>
                                </div>
                                  <div v-for="(role,index) in user_roles" :key="index+'ur'">
                                      <v-icon left small color="error" v-if="!lock" @click="remove(index,'user_roles')">mdi-close</v-icon>{{role}}
                                    <v-divider class="mt-1 mb-1"/>
                                </div>
                               
                              </v-col>
                               <v-col cols="4">
                                    <p class="font-weight-bold"><v-icon left>mdi-archive-cog</v-icon> Product Categories</p>

                                     <div class="mt-4 mb-4">
                                        <v-text-field
                                            v-model="new_cat"
                                            dense
                                            :disabled="lock"
                                            label="New Category Name"
                                            hide-details
                                            solo
                                          @click:append-outer = "newCat()"
                                            append-outer-icon="mdi-plus"
                                          ></v-text-field>
                                    </div>
                                  <div v-for="(cat,index) in product_types" :key="index+'pc'">
                                      <v-icon left small color="error" v-if="!lock" @click="remove(index,'product_types')">mdi-close</v-icon> {{cat}}
                                    <v-divider class="mt-1 mb-1"/>
                                </div>
                           </v-col> 
                           

                           <v-col cols="4">
                                    <p class="font-weight-bold"><v-icon left>mdi-currency-php-off</v-icon> Expenses Category</p>

                                     <div class="mt-4 mb-4">
                                        <v-text-field
                                            v-model="expense"
                                            dense
                                            label="New Expenses Category"
                                            hide-details
                                            :disabled="lock"
                                            solo
                                          @click:append-outer = "newExpense()"
                                            append-outer-icon="mdi-plus"
                                          ></v-text-field>
                                    </div>
                                  <div v-for="(name,index) in expenses_categories" :key="index+'xc'">
                                      <v-icon left small color="error" v-if="!lock" @click="remove(index,'expenses_categories')">mdi-close</v-icon> {{name}}
                                    <v-divider class="mt-1 mb-1"/>
                                </div>
                           </v-col> 

                           
                           <v-col cols="4">
                                    <p class="font-weight-bold"><v-icon left>mdi-application-cog-outline</v-icon> Others</p>
                               <table class="va-table va-table-border-bot">
                                <tr>
                                  <td width="30%" class="text-right font-weight-bold"><span class="pa-8">Tax:</span></td>
                                  <td>
                                       <v-text-field
                                        v-model="tax"
                                        :disabled="lock"
                                        @change="Update('tax', tax)"
                                        label="Tax Percentage"
                                        hint="Set value to 0 to disable tax on sales"
                                        persistent-hint
                                        dense
                                        solo
                                        
                                      ></v-text-field>
                                  </td>
                                </tr>
                               </table>
                                 
                           </v-col>  
                         
                      </v-row>   
                      
                  </v-card-text>
                 </v-card>
             </v-col>
       </v-row>
       </v-container>
       <va-bay-form :show="bayform" :data="service_bay" :state="state" @DialogEvent="bayEvent" />
     </div>
   </template>
   <script>
   import {
     mapMutations
   } from 'vuex'
     export default {
       data: () => ({
        lock: true,
           form: false,
           transaction: false,
           search:"",
           selectedID:  null,
           trans_dailog: false,
           s3upload: false,
           state: 'new',
           company_name:"",
           company_address:"",
           company_mobile:"",
           company_tel:"",
           company_email:"",
           company_logo:"",
           user_roles: [],
           expenses_categories:[],
           new_role:"",
           new_cat: "",
           tax:'',
           expense:"",
           product_types: [],
           user:{profile:{picture:""}},
           items:[],
           service_bays:[],
           service_bay: {},
           bayform: false,
           view: {
              per_page: 50,
              current_page: 1,
              pagination: true
           }
       }),
       beforeCreate: function () {
         if (!this.$session.exists()) {
           this.$router.push('/')
         }
       },
       created() {
          if (this.$session.exists()) {
             this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
             this.setLoggedIn(true) 
              this.CHECKPAGEPERMISSION()
             this.SETVARS()
             this.getServiceBay()
             setTimeout(()=>{
              this.setValues()
            },300)
            
           }
       },
       computed:{
          ROLES(){
            return this.user_roles
          }
       },
       methods: {
         ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn','setVariables']),
        bayEvent(){
          this.bayform = false
          this.getServiceBay()
        },
         s3Ev(e){
          if(e) {
            this.company_logo = e[0]
            this.s3upload = false
            this.Update("company_logo", this.company_logo)
          }
      
        },
      setValues(){
      
        this.company_name = this.GET_SYSVARS('company_name')
        this.company_address = this.GET_SYSVARS('company_address')
        this.company_mobile = this.GET_SYSVARS('company_mobile')
        this.company_tel = this.GET_SYSVARS('company_tel')
        this.company_email  = this.GET_SYSVARS('company_email')
        this.company_logo = this.GET_SYSVARS('company_logo')
        this.tax =  this.GET_SYSVARS('tax')
        this.user_roles = this.GET_SYSVARS('user_roles')
        this.product_types = this.GET_SYSVARS('product_types')
        this.expenses_categories = this.GET_SYSVARS('expenses_categories')
      },
      remove(index, field){
        if(field == "user_roles") {
            this.user_roles.splice(index,1)
            var roles = this.user_roles.join(",")
            this.Update("user_roles", roles)
        }  else if(field == "product_types"){
             this.product_types.splice(index,1)
            var categories = this.product_types.join(",")
            this.Update("product_types", categories)
        } else if(field == "expenses_categories"){
             this.expenses_categories.splice(index,1)
            var expenses = this.expenses_categories.join(",")
            this.Update("expenses_categories", expenses)
        }
        
      },
      newExpense(){
           if(this.expense.length < 3) {
          this.VA_ALERT("error", "Expenses Name is too short!", "close", 500, 2000)
          return
        }
        this.expenses_categories.push(this.$capitalize(this.expense))
        var items = this.expenses_categories.join(",")
        this.Update("expenses_categories", items)
        this.expense = ""
      },
      newCat(){
        if(this.new_cat.length < 3) {
          this.VA_ALERT("error", "Category Name is too short!", "close", 500, 2000)
          return
        }
        this.product_types.push(this.$capitalize(this.new_cat))
        var categories = this.product_types.join(",")
        this.Update("product_types", categories)
        this.new_cat = ""
      },
      newRole(){
          if(this.new_role.length < 3) {
          this.VA_ALERT("error", "User role is too short!", "close", 500, 2000)
          return
        }
        this.user_roles.push(this.$capitalize(this.new_role))
        var roles = this.user_roles.join(",")
        this.Update("user_roles", roles)
        this.new_role = ""
      },
    Update(field, value){

           let params = {
            table: "variables", 
            type:"update",
            query:`update variables set  value='${value}' where name='${field}'`
        }
   
              this.$http.post("new_data", params).then(response => {
                console.log(response)
                this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
                this.SETVARS()
                setTimeout(()=>{
                  this.setValues()
                },500)
              }).catch(e => {
                console.log(e.data)
              })
        },
      getServiceBay(){
          this.service_bays = []
          this.QUERY('sales',`select * from service_bays order by id asc`, (res)=>{
              this.service_bays = res.results    
          })
      } 
     }
 }
   </script>